/*
import {
  hf,
  ht,
  f,
} from 'lib';
*/
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as ht from './_ht';
import * as hf from './_hf';

import * as ihd from './ihd';

export const ilzI16z = () => ({
  i16rz: {},
}) as ht.dz;

export const crtI16zAsync = async () => {
  //const _gUserz = gs.useUserz();
  const _i16z = ilzI16z();
  hf.udtDz(_i16z.i16rz, {
    ... ihd.i('i16r'),
    //i16r_31r1f: _gUserz.crt._31rz._fst,
  });
  return _i16z;
};

export const loadI16rLsAsync = async (
) => {
  //const _gUserz = gs.useUserz();
  //const _cdn = cmFTH.vdd() + ` AND i16r_31r1f=${_gUserz.crt._31rz?._fst}`;
  const _cdn = cmFTH.vdd(); // 施設共通
  //hf.l(`IcvI16 29: ${_cdn}`);
  const _ls = await cmFTH.loadLsAsync({
    tgt: 'i16rs',
    cdn: _cdn,
  });
  return _ls;
};

export const loadI16rDzAsync = async (pz: {
  i16r_fst: ht.n,
  vsn?: ht.n,
}) => {
  //const _gUserz = gs.useUserz();
//  let _cdn = cmFTH.vdd() + ` AND i16r_31r1f=${_gUserz.crt._31rz._fst}`;
//  let _cdn = cmFTH.vdd(); // 施設共通
  let _cdn = (pz?.vsn && pz?.vsn > 0) ? (cmFTH.vdd(false) + ` AND _vsn = ${pz?.vsn}`) : cmFTH.vdd();
  if (pz.i16r_fst) _cdn += ` AND _fst = ${pz.i16r_fst}`;
  //hf.l(`IcvI16 40: ${_cdn}`);
  const _dz = await cmFTH.loadDzAsync({
    tgt: 'i16rs',
    cdn: _cdn,
  });
  return {
    i16rz: _dz
  };
};

export const saveI16rDzAsync = async (pz: {
  i16z: ht.dz,
  sPz?: ht.dz,
}) => {
  //hf.l(`IcvI16b 57: ${hf.s(pz.i16z)}`);
  const _dz = await cmFTH.ugdDzAsync({
    tgt: 'i16rs',
    dz: {
      ... pz.i16z.i16rz,
    },
  });
  //hf.l(`IcvI16b 63: ${hf.s(_dz)}`);
  return {
    i16rz: { ... _dz, cldz: undefined, }
  };
};
